//@flow
import React, { Component } from 'react';
import { SwitchIcon, SwitchSpan } from './SwitchStyles';

type Props = {
  handleClick: number => void,
  orderState: number,
  text: string
};

export default class Switch extends Component<Props> {
  handleSwitchFill = (buttonType: string) => {
    if (buttonType === 'up') {
      switch (this.props.orderState) {
        case 0:
        case 2:
          return 'black';
        case 1:
          return 'dustierGray';
        default:
          break;
      }
    }
    if (buttonType === 'down') {
      switch (this.props.orderState) {
        case 0:
        case 1:
          return 'black';
        case 2:
          return 'dustierGray';
        default:
          break;
      }
    }
  };

  handleSwitchClick = () => () => {
    if (this.props.orderState !== 2) {
      this.props.handleClick(this.props.orderState + 1);
    } else {
      this.props.handleClick(0);
    }
  };

  render() {
    return (
      <SwitchSpan>
        <div onClick={this.handleSwitchClick()}>
          <p>{this.props.text} </p>
          <span>
            <SwitchIcon name={'upSwitch'} fill={this.handleSwitchFill('up')} />
            <SwitchIcon
              name={'downSwitch'}
              fill={this.handleSwitchFill('down')}
            />
          </span>
        </div>
      </SwitchSpan>
    );
  }
}
